<template ref="child3">
  <section class="section" data-filter-group>
    <div class="head">
      <h4 class="c-title-level4">{{ props.categoryName }}</h4>
      <button
        v-if="isShowplusButton"
        type="button"
        class="btn-expand is-more"
        :class="{
          'is-expand': isShowCategoryMore,
        }"
        @click="() => (isShowCategoryMore = !isShowCategoryMore)"
      >
        <span class="sr-only">펼침</span>
      </button>
    </div>
    <div
      class="options"
      :class="{ 'is-visible': isShowCategoryMore }"
      ref="categoryRef"
    >
      <button
        v-for="item in categories"
        :key="item.clsfCd"
        type="button"
        class="c-option-item"
        :class="{
          'is-active': item.selected,
        }"
        @click="changeSelect(item)"
      >
        <span class="text"
          >{{ item.clsfNm }}(<span class="system">{{
            Utils.currency(item.productCount)
          }}</span
          >)</span
        >
      </button>
    </div>
  </section>
</template>
<script setup>
import {
  onMounted,
  defineModel,
  defineProps,
  ref,
  defineEmits,
  onBeforeUnmount,
  computed
} from "vue";
import Utils from "@/js/utils";

const emits = defineEmits(["selectChanged"]);
const categories = defineModel("categories", { required: true });

const props = defineProps({
  categoryName: {
    type: String,
    default: "",
  },
});

const isShowCategoryMore = ref(false);
const categoryRef = ref();
const categorySize = ref({
  clientHeight: 0,
  scrollHeight: 0,
});

onMounted(() => {
  window.addEventListener("resize", onWindowResize);
  onWindowResize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onWindowResize);
});

const onWindowResize = () => {
  categorySize.value = {
    clientHeight: categoryRef.value.clientHeight,
    scrollHeight: categoryRef.value.scrollHeight,
  };
};

const isShowplusButton = computed(() => {
  //const ROW_HEIGHT = 170; // 3행의 높이는 대략 160이라 약간 더 높은 기준을 설정합니다.

  //return categorySize.value.scrollHeight > ROW_HEIGHT;
  return true;
});

const changeSelect = (item) => {
  item.selected = !item.selected;
  emits("selectChanged");
};
</script>
